// Utility for DataTable (CTA logic)
import { getAgeFromDob } from '@/hooks/useFamily';
import type { MemberInfo } from '@/types/member';

/**
 * Determines if a member is eligible for invite based on age (>= 18) and member type.
 * Returns false if member is a pet or under 18, true otherwise.
 */
export function canShowInviteCTA(member: MemberInfo): boolean {
  // If pet, never show invite
  if (member.memberType === 'p' || Number(member.relationship) === 6) return false;
  // Compute age from dob fields (accepts both camelCase and snake_case)
  const dobDay = member.dobDay || member.dobDay;
  const dobMonth = member.dobMonth || member.dobMonth;
  const dobYear = member.dobYear || member.dobYear;
  const age = getAgeFromDob(dobDay, dobMonth, dobYear);
  if (age !== null && age < 18) return false;
  return true;
}
